import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import Received from './screens/Received/router';
import Sended from './screens/Sended/router';
export default (
  <Route
    path="stickynotes"
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  >
  {Received}
  {Sended}
  <IndexRedirect to="received" />
  </Route>
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/StickyNotes/router.js
 **/